
import React from 'react';
import './BookingForm.css';

function BookingForm() {
  return (
    <section className="booking-section">

      <div className="booking-container">

        <div className="booking-left">

          <p>BOOK A SERVICE</p>

          <h2>
            Ready To Refresh
            Your Space?
          </h2>

          <span>
            Book professional mobile car wash,
            house cleaning, and Airbnb cleaning
            services anywhere in Cape Town.
          </span>

          <div className="booking-info">

            <div className="info-card">
              <h4>📍 Location</h4>
              <p>Muizenberg, Cape Town</p>
            </div>

            <div className="info-card">
              <h4>📞 Phone</h4>
              <p>+27 76 720 1554</p>
            </div>

            <div className="info-card">
              <h4>🕒 Availability</h4>
              <p>Mon - Sat | 8AM - 6PM</p>
            </div>

          </div>

        </div>

        <div className="booking-right">

          <form className="booking-form">

            <input
              type="text"
              placeholder="Full Name"
            />

            <input
              type="email"
              placeholder="Email Address"
            />

            <input
              type="text"
              placeholder="Phone Number"
            />

            <select>
              <option>Select Service</option>
              <option>Mobile Car Wash</option>
              <option>House Cleaning</option>
              <option>Airbnb Cleaning</option>
            </select>

            <textarea
              rows="5"
              placeholder="Tell us about the service you need..."
            ></textarea>

          
<a
  href="mailto:info@reasonableservices.co.za"
  className="email-book-btn"
>
  Book Service
</a>



          </form>

        </div>

      </div>

    </section>
  );
}

export default BookingForm;



